import { apiClient } from './api'

export const DEFAULT_PRODUCT = 'SALMA_CARGO_3D'
export type SubscriptionStatus = 'TRIALING' | 'ACTIVE' | 'EXPIRED' | 'CANCELED' | 'SUSPENDED'
export interface SubscriptionSummary {
  product: string
  access?: { canRead: boolean; canWrite: boolean }
  subscription: {
    id: string; plan: string; status: SubscriptionStatus; startAt: string
    periodStart: string; periodEnd: string; trialStart: string | null; trialEnd: string | null
    licensedUsers: number; cancelAtPeriodEnd: boolean
    usedUsers: number; remainingUsers: number; pendingLicensedUsers: number | null; prepaidPeriodEnd: string | null
    price: { currency: string; amountTtc: string; intervalUnit: string; intervalCount: number } | null
    access: { canRead: boolean; canWrite: boolean }
    retention: { state: string; dataRetentionUntil: string | null; automaticDeletion: false } | null
  } | null
}
export interface Entitlements {
  product: string
  subscription: { plan: string; status: SubscriptionStatus; periodEnd: string }
  features: Record<string, boolean>
  limits: Record<string, { limit: number | null; used: number | null; remaining: number | null }>
}
export const subscriptionService = {
  async subscription(product = DEFAULT_PRODUCT): Promise<SubscriptionSummary> {
    return (await apiClient.get('/api/me/subscription', { params: { product }, timeout: 15000 })).data.data
  },
  async entitlements(product = DEFAULT_PRODUCT): Promise<Entitlements> {
    return (await apiClient.get('/api/me/entitlements', { params: { product } })).data.data
  },
}
